import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Button, CircularProgress } from '@mui/material'

import { SubmitButtonProps } from './controls.types.ts'

export const SubmitButton = ({
  children,
  size = 'large',
  color = 'primary',
  disabled,
  ...props
}: SubmitButtonProps): React.ReactElement => {
  const { formState } = useFormContext()
  const { isValid, isSubmitting } = formState

  // показывает ошибки при открытии формы, надо сделать управляемым параметром
  // useEffect(() => {
  //   // на случай если в форму передали defaultValues,
  //   // надо запустить проверку на корректность данных для отображения ошибок
  //   //trigger()
  // }, [])

  // тк с бэка приходит ответ 200 с ошибкой внутри тела
  // мы не может опираться на этот флаг чтобы ресетить формы универсально 🤡
  // useEffect(() => {
  //   if (isSubmitSuccessful) {
  //     reset()
  //   }
  // }, [isSubmitSuccessful])

  return (
    <Button
      variant="contained"
      fullWidth
      disabled={disabled || !isValid || isSubmitting}
      type="submit"
      color={color}
      size={size}
      {...props}
    >
      {isSubmitting ? <CircularProgress color="inherit" size={16} /> : children}
    </Button>
  )
}
